import React, { useEffect, useState } from "react";
import { useSubheader } from "../../_metronic/layout";
import {
  makeStyles,
  Paper,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  TableHead,
  TableSortLabel,
} from "@material-ui/core";
import httpClientService from "../helpers/apiHelper";
import { shallowEqual, useSelector } from "react-redux";
import setRowsPerPageOptions from "../helpers/tableHelper";
import _ from "lodash"; 
// components
import TokenAlert from "../components/TokenAlert";
import { Spinner } from "react-bootstrap";
import SnackBar from "../components/SnackBar";
import { useHistory } from "react-router-dom";
import Config from "../helpers/Config";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(3),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  select: {
    minWidth: 200, 
  },
  //input
  input: {
    width: 200,
  },
  textField: {
    // marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  annotation: {
    color: "grey",
  },
  tableRow: {
    cursor: "pointer",
  },
  contantWidth: {
    width: "500px",
  },
}));

export default function DashboardPage() {
  const domin = Config.get("API_HOST");
  const history = useHistory();
  const suhbeader = useSubheader();
  const classes = useStyles();
  const pagiOption = setRowsPerPageOptions();
  const authToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
  suhbeader.setTitle("");

  const [data, setData] = React.useState("");
  const [rows, setRows] = React.useState([]);
  // const [openDialog, setopenDialog] = React.useState(false);
  // pagination相關參數
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [total, setTotal] = useState(0);
  //是否在讀取
  const [loading, setLoading] = useState(false);
  // token驗證
  const [hasntToken, setHasntToken] = React.useState("");
  // 錯誤處理
  const [err, seterr] = React.useState("");

  const [messageInfo, setmessageInfo] = useState({
    err: "",
    snackOpen: false,
  });

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };


  // 獲取初始資料
  function getData() {
    enableLoading();
    httpClientService(
      "get",
      `${domin}/vendor/announce?limit=30&offset=1`, 
      authToken,
      {}
    )
      .then((res) => {
        console.log("res = ", res);
        if (_.get(res, "result") === false) {
          if (
            _.get(res, "msg") ===
            ("查無此Token，請重新登入" || "此Token失效，請重新登入" || "登入失敗查無此Token，請重新登入")
          ) {
            setHasntToken(res.msg);
            disableLoading();
            return;
          }

          if (
            res.msg ===
            ("登入失敗")
          ) {
            setmessageInfo({
              ...messageInfo,
              success: "",
              err: res.msg,
              snackOpen: true,
            });
            setTimeout(()=>{history.replace('/logout')})
            return;
          }
          // seterr(res.msg);
          setmessageInfo({ err: res.msg, snackOpen: true });
          // messageConfirmOpen();
          disableLoading();
          return;
        } else {
          // console.log('l127');
          setmessageInfo({ err: "" });
          setData(_.get(res, "data"));
          setRows(_.get(res, "data.rows"));
          setTotal(_.get(res, "data.total"));
          setRowsPerPage(_.get(res, "data.pre_page"));
          setPage(0);
        }

        disableLoading();
      })
      .catch((err) => {
        console.log(err);
        setmessageInfo(state=>({...state, err: err.toString(), snackOpen: true }));
        disableLoading();
        return;
      });
  }

  // 上下頁的按鈕
  const handleChangePage = (event, newPage) => {
    console.log("newPage:", newPage);
    console.log("page:", page);
    console.log("rowsPerPage:", rowsPerPage);
    console.log("total:", total);
    let url = `${domin}/vendor/announce?limit=${rowsPerPage}&offset=${newPage *
      rowsPerPage +
      1}`;
    // ${domin}/order/service?sort=${property}/${trueOrder}&limit=${rowsPerPage}&offset=1
    // if(orderServiceId){
    //   url+=`order_code=${orderServiceId}&`;
    // }

    // if (!orderBy) {
    //   url+= `status=${status}&limit=${rowsPerPage}&offset=${newPage *
    //     rowsPerPage +
    //     1}`;
    // } else {
    //   url += `sort=${orderBy}/${order}&status=${status}&limit=${rowsPerPage}&offset=${newPage *
    //     rowsPerPage +
    //     1}`;
    // }

    enableLoading();
    httpClientService("get", url, authToken, {})
      .then((res) => {
        if (_.get(res, "result") === false) {
          if (
            _.get(res, "msg") ===
            ("查無此Token，請重新登入" || "此Token失效，請重新登入" || "登入失敗查無此Token，請重新登入")
          ) {
            setHasntToken(_.get(res, "msg"));
            disableLoading();
            return;
          }

          if (
            res.msg ===
            ("登入失敗")
          ) {
            setmessageInfo({
              ...messageInfo,
              success: "",
              err: res.msg,
              snackOpen: true,
            });
            setTimeout(()=>{history.replace('/logout')})
            return;
          }

          setmessageInfo({ err: res.msg, snackOpen: true })
          disableLoading();
        }
        setmessageInfo({ err: '' })
        console.log("res:", res);
        setRows(_.get(res, "data.rows"));
        setData(res);
        setPage(newPage);
        setRowsPerPage(_.get(res, "data.pre_page"));
        setTotal(_.get(res, "data.total"));
      })
      .catch((err) => {
        console.log(err);
        setmessageInfo({ err: err.toString(), snackOpen: true })
        disableLoading();
      })
      .finally(() => {
        disableLoading();
      });

    setPage(newPage);
  };

  // 選擇筆數
  const handleChangeRowsPerPage = (event) => {
    console.log("handleChangeRowsPerPage:", +event.target.value);
    const newRowsPerPage = event.target.value;

    let url = `${domin}/vendor/announce?limit=${newRowsPerPage}&offset=1`;

    if (!orderBy) {
      // url = `${domin}/order/service?status=${status}&limit=${newRowsPerPage}&offset=1`;
    } else {
      // url = `${domin}/order/service?sort=${orderBy}/${order}&status=${status}&limit=${newRowsPerPage}&offset=1`;
    }

    enableLoading();
    httpClientService("get", url, authToken, {})
      .then((res) => {
        if (_.get(res, "result") === false) {
          if (
            _.get(res, "msg") ===
            ("查無此Token，請重新登入" || "此Token失效，請重新登入" || "登入失敗查無此Token，請重新登入")
          ) {
            setHasntToken(_.get(res, "msg"));
            disableLoading();
            return;
          }

          if (
            res.msg ===
            ("登入失敗")
          ) {
            setmessageInfo({
              ...messageInfo,
              success: "",
              err: res.msg,
              snackOpen: true,
            });
            setTimeout(()=>{history.replace('/logout')})
            return;
          }

          setmessageInfo({ err: res.msg, snackOpen: true })
          disableLoading();
          return;
        }

        console.log("res:", res);
        setmessageInfo({ err: ''})

        setRows(_.get(res, "data.rows"));
        setData(res);
        setPage(0);
        setRowsPerPage(_.get(res, "data.pre_page"));
        setTotal(_.get(res, "data.total"));
      })
      .catch((err) => {
        console.log(err);
        setmessageInfo({ err: err.toString(), snackOpen: true })
      })
      .finally(() => {
        disableLoading();
      });

    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // EnhancedTableHead---------------------------------------------------------------------------

  const headCells = [
    { id: "name", label: "標題", sortable: false },
    { id: "id", label: "id", sortable: false },
    { id: "category", label: "類別", sortable: false },
    { id: "create_date", label: "發佈時間", sortable: false },
    { id: "content", label: "公告內容", sortable: false },
  ];

  const [order, setOrder] = React.useState("");
  const [orderBy, setOrderBy] = React.useState("");

  // 排序
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    const trueOrder = isAsc ? "desc" : "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    console.log("order = ", order);
    console.log("orderBy = ", orderBy);
    enableLoading();
    httpClientService(
      "get",
      `${domin}/vendor/announce?sort=${property}/${trueOrder}&limit=${rowsPerPage}&offset=1`,
      authToken,
      {}
    )
      .then((res) => {
        console.log("res = ", res);
        if (res.result === false) {
          if (
            _.get(res, "msg") ===
            ("查無此Token，請重新登入" || "此Token失效，請重新登入" || "登入失敗查無此Token，請重新登入")
          ) {
            setHasntToken(_.get(res, "msg"));
            disableLoading();
            return;
          }

          if (
            res.msg ===
            ("登入失敗")
          ) {
            setmessageInfo({
              ...messageInfo,
              success: "",
              err: res.msg,
              snackOpen: true,
            });
            setTimeout(()=>{history.replace('/logout')})
            return;
          }

          setmessageInfo({ err: err.msg, snackOpen: true })
          disableLoading();
          return;
        }

        if (_.get(res, "stackTrace")) {
          setmessageInfo({ err: err.toString(), snackOpen: true })
          disableLoading();
        }
        setmessageInfo({ err: err.msg, snackOpen: true })
        setPage(0);
        setData(_.get(res, "data"));
        setRows(_.get(res, "data.rows"));
        setTotal(_.get(res, "data.total"));
      })
      .catch((err) => {
        console.log("err = ", err);
        setmessageInfo({ err: err.toString(), snackOpen: true })
        disableLoading();
      })
      .finally(() => {
        disableLoading();
      });
  };

  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      console.log(property);
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.sortable ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {/* {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null} */}
                </TableSortLabel>
              ) : (
                <div>{headCell.label}</div>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  // EnhancedTableHead---------------------------------------------------------------------------

  return (
    <>
      {hasntToken ? (
        <TokenAlert showMsg={hasntToken}></TokenAlert>
      ) : loading ? (
        <Spinner animation="border" variant="primary" className="mt-2 ml-2" />
      ) : !data ? (
        <></>
      ) : (
        <>
          <Paper className={classes.paper + " p-5"}>
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                className="d-flex align-items-center justify-content-center"
              >
                <h3 className="text-dark font-weight-bold mb-2">公告放置區</h3>
              </Grid>
            </Grid>
            <Table
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <EnhancedTableHead
                // classes={classes2}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {rows.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.category}</TableCell>
                      <TableCell>{row.create_date}</TableCell>
                      <TableCell className={`${classes.contantWidth}`}>
                        {row.content}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            {_.get(data, "data[rows]") <= 1 ? (
              <></>
            ) : (
              <TablePagination
                rowsPerPageOptions={pagiOption}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                className="pr-10"
              />
            )}
          </Paper>
          <SnackBar
          open={messageInfo.snackOpen}
            // open={true}
            onClose={() =>
              setmessageInfo((state) => ({
                ...state,
                snackOpen: false,
              }))
            }
            time={5000}
            severity={messageInfo.err ? "error" : "success"}
            message={messageInfo.err}
            data={{
              freightCode: "",
              freightName: "",
            }}
          />
          {/* <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                className="d-flex align-items-center justify-content-center"
              >
                <h3 className="text-dark font-weight-bold">公告放置區</h3>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                className="d-flex align-items-center justify-content-center"
              >
                <div className={classes.annotation}>
                  這裡主要放置公告相關，可以依照訊息長度或特殊需求變更擺放的位置
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                className="d-flex align-items-center justify-content-center"
              >
                <div className={classes.annotation}>
                  可以點左上方的SPM供應商系統字樣來到公告區
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                className="d-flex align-items-center justify-content-center"
              >
                <div className={classes.annotation}>
                  左邊列表列出了可以使用的功能，可以點進去查看
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                className="d-flex align-items-center justify-content-center"
              >
                <div className={classes.annotation}>
                  右上角的Sign Out可以進行登出，切換使用者
                </div>
              </Grid>
            </Grid> */}
        </>
      )}
    </>
  );

  // return <Dashboard />;
}
